import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/app-setting/redux/actions';
import { UserTokenForm } from './UserTokenForm';
import { CustomModal } from '../../../common/ui/CustomModal';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import DevApiKey from './DevApiKey';
import { CollectionConfig } from '..';
import PermissionDenied from '../../../common/PermissionDenied';
import { checkDeveloperAPIPermission } from '../../../common/utils/permissions';
import EmbeddedPageFrame from '../../common/ui/EmbeddedPageFrame';
import { DEVELOPER_API } from 'drapcode-constant';

export class CollectionDevApi extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    isOpen: false,
    user: null,
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  setUser = (user) => {
    this.setState({ user: user });
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
    actions.loadAllDevApis({ projectId, version });
    actions.loadUserRoles({ projectId, version });
    actions.loadPermissions({ projectId, version });
    actions.loadEmailTemplates({ projectId, version });
    actions.loadProjectCollections({ projectId, version });
  }

  render() {
    const isAllowed = checkDeveloperAPIPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Developer API" />;
    }
    let domainName = window.location.hostname;
    const developerApiDomain = domainName.split('.')[0];
    const { isOpen, user } = this.state;

    const { appSetting, actions, permission, match } = this.props;
    const { projectDetail, permissionFlags } = appSetting;
    if (!projectDetail) {
      return '';
    }
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { projectId, version } = match.params;
    const { environments } = projectDetail;
    const deleteFlag = permissionsArray.includes(DEVELOPER_API);
    return (
      <EmbeddedPageFrame embedded={this.props.embedded}>
        <CustomModal
          isOpen={isOpen}
          toggle={this.toggle}
          header="Generate User Token"
          size="lg"
          body={
            <UserTokenForm
              projectId={projectId}
              environments={environments}
              projectDetail={projectDetail}
              user={user}
              version={version}
              setUser={this.setUser}
            />
          }
        />

        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="row mx-auto">
            <ParentCardNoCol
              title="Developer API Key"
              bgColor="drapcode-violet"
              icon="devKey"
              CtaComponent={
                <button className="btn btn-theme-submit btn-md" onClick={this.toggle}>
                  <i className="webconnect webconnect-person-badge-fill" />
                  &nbsp; Generate User Token
                </button>
              }
            >
              <DevApiKey
                appSetting={appSetting}
                projectDetail={projectDetail}
                projectId={projectId}
                developerApiDomain={developerApiDomain}
                version={version}
                actions={actions}
                deleteFlag={deleteFlag}
              />
            </ParentCardNoCol>
          </div>
          <div className="row mx-auto">
            <ParentCardNoCol title="Developer API" bgColor="drapcode-violet" icon="External APIs">
              <CollectionConfig projectId={projectId} version={version} />
            </ParentCardNoCol>
          </div>
        </div>
      </EmbeddedPageFrame>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDevApi);
